/**
 * GENERATED FILE — DO NOT EDIT BY HAND.
 *
 * Source:    tools/golden/oracle/Calcul_structures_EC3_EC5.frozen.html
 * SHA-256:   d7b05cd2db5150e19f8514bd434baac13d31bd942e0a726d00f82e35b77746e8
 * Regenerate: node packages/catalog/scripts/generate-catalog.mjs
 *
 * The numbers below are reproduced exactly as the frozen oracle holds them, including values that
 * look like they want tidying (`iy: 32.400000000000006`, `A: 1639.9999999999998`). They are
 * float artefacts of the original spreadsheet export and they are part of the bit-exact baseline:
 * rounding one changes an engineering result, changes `CATALOG_HASH`, and breaks every golden
 * fixture. Do not "fix" them.
 *
 * Row counts:
 *  - `profils`: 133
 *  - `nuances`: 5
 *  - `schemas`: 5
 *  - `creux`: 145
 *  - `fabrication`: 2
 *  - `bois`: 16
 *  - `kmod`: 3
 *  - `duree`: 5
 *  - `kdef`: 3
 *
 * Editing this file by hand is a mistake in two directions: the next `generate-catalog.mjs` run
 * reverts it, and `tools/golden/test/catalog-parity.test.ts` fails in the meantime. A genuine
 * data change belongs in the source data plus a `CATALOG_VERSION` bump (see README.md).
 */

import type { Catalog } from './types';

/**
 * The complete `window.DB` catalog, typed. Per-table row interfaces (`SteelProfile`,
 * `SteelGrade`, `LoadScheme`, `HollowSection`, `Fabrication`, `TimberClass`, `KmodRow`,
 * `KdefRow`) live in `./types` and are re-exported from the package entry point.
 */
export const CATALOG: Catalog = {
  profils: [
    {
      nom: 'IPE 80',
      fam: 'I',
      h: 80,
      b: 46,
      tw: 3.8,
      tf: 5.2,
      r: 5,
      A: 764,
      Iy: 801000,
      Wely: 20000,
      Wply: 23200,
      iy: 32.400000000000006,
      Iz: 84900,
      Welz: 3690,
      Wplz: 5820,
      iz: 10.5,
      It: 7000,
      Iw: 118000000,
      G: 6,
    },
    {
      nom: 'IPE 100',
      fam: 'I',
      h: 100,
      b: 55,
      tw: 4.1,
      tf: 5.7,
      r: 7,
      A: 1030,
      Iy: 1710000,
      Wely: 34200,
      Wply: 39400,
      iy: 40.7,
      Iz: 159000,
      Welz: 5790,
      Wplz: 9150,
      iz: 12.4,
      It: 12000,
      Iw: 342000000,
      G: 8.1,
    },
    {
      nom: 'IPE 120',
      fam: 'I',
      h: 120,
      b: 64,
      tw: 4.4,
      tf: 6.3,
      r: 7,
      A: 1320,
      Iy: 3180000,
      Wely: 53000,
      Wply: 60700,
      iy: 49,
      Iz: 277000,
      Welz: 8650,
      Wplz: 13600,
      iz: 14.5,
      It: 17400,
      Iw: 890000000,
      G: 10.4,
    },
    {
      nom: 'IPE 140',
      fam: 'I',
      h: 140,
      b: 73,
      tw: 4.7,
      tf: 6.9,
      r: 7,
      A: 1639.9999999999998,
      Iy: 5410000,
      Wely: 77300,
      Wply: 88300,
      iy: 57.400000000000006,
      Iz: 449000,
      Welz: 12300,
      Wplz: 19200,
      iz: 16.5,
      It: 24500,
      Iw: 1980000000,
      G: 12.9,
    },
    {
      nom: 'IPE 160',
      fam: 'I',
      h: 160,
      b: 82,
      tw: 5,
      tf: 7.4,
      r: 9,
      A: 2010.0000000000002,
      Iy: 8690000,
      Wely: 109000,
      Wply: 124000,
      iy: 65.8,
      Iz: 683000,
      Welz: 16700,
      Wplz: 26100,
      iz: 18.400000000000002,
      It: 36000,
      Iw: 3960000000,
      G: 15.8,
    },
    {
      nom: 'IPE 180',
      fam: 'I',
      h: 180,
      b: 91,
      tw: 5.3,
      tf: 8,
      r: 9,
      A: 2390,
      Iy: 13170000,
      Wely: 146000,
      Wply: 166000,
      iy: 74.2,
      Iz: 1010000,
      Welz: 22200,
      Wplz: 34600,
      iz: 20.5,
      It: 47900,
      Iw: 7430000000,
      G: 18.8,
    },
    {
      nom: 'IPE 200',
      fam: 'I',
      h: 200,
      b: 100,
      tw: 5.6,
      tf: 8.5,
      r: 12,
      A: 2850,
      Iy: 19430000,
      Wely: 194000,
      Wply: 221000,
      iy: 82.6,
      Iz: 1420000,
      Welz: 28500,
      Wplz: 44600,
      iz: 22.400000000000002,
      It: 69800,
      Iw: 12990000000,
      G: 22.4,
    },
    {
      nom: 'IPE 220',
      fam: 'I',
      h: 220,
      b: 110,
      tw: 5.9,
      tf: 9.2,
      r: 12,
      A: 3340,
      Iy: 27720000,
      Wely: 252000,
      Wply: 285000,
      iy: 91.1,
      Iz: 2050000,
      Welz: 37300,
      Wplz: 58100,
      iz: 24.8,
      It: 90700,
      Iw: 22670000000,
      G: 26.2,
    },
    {
      nom: 'IPE 240',
      fam: 'I',
      h: 240,
      b: 120,
      tw: 6.2,
      tf: 9.8,
      r: 15,
      A: 3910,
      Iy: 38920000,
      Wely: 324000,
      Wply: 367000,
      iy: 99.7,
      Iz: 2840000,
      Welz: 47300,
      Wplz: 73900,
      iz: 26.9,
      It: 129000,
      Iw: 37390000000,
      G: 30.7,
    },
    {
      nom: 'IPE 270',
      fam: 'I',
      h: 270,
      b: 135,
      tw: 6.6,
      tf: 10.2,
      r: 15,
      A: 4590,
      Iy: 57900000,
      Wely: 429000,
      Wply: 484000,
      iy: 112,
      Iz: 4200000,
      Welz: 62200,
      Wplz: 97000,
      iz: 30.2,
      It: 159000,
      Iw: 70580000000,
      G: 36.1,
    },
    {
      nom: 'IPE 300',
      fam: 'I',
      h: 300,
      b: 150,
      tw: 7.1,
      tf: 10.7,
      r: 15,
      A: 5380,
      Iy: 83560000,
      Wely: 557000,
      Wply: 628000,
      iy: 125,
      Iz: 6040000,
      Welz: 80500,
      Wplz: 125000,
      iz: 33.5,
      It: 201000,
      Iw: 125900000000,
      G: 42.2,
    },
    {
      nom: 'IPE 330',
      fam: 'I',
      h: 330,
      b: 160,
      tw: 7.5,
      tf: 11.5,
      r: 18,
      A: 6260,
      Iy: 117700000,
      Wely: 713000,
      Wply: 804000,
      iy: 137,
      Iz: 7880000,
      Welz: 98500,
      Wplz: 154000,
      iz: 35.5,
      It: 281000,
      Iw: 199100000000,
      G: 49.1,
    },
    {
      nom: 'IPE 360',
      fam: 'I',
      h: 360,
      b: 170,
      tw: 8,
      tf: 12.7,
      r: 18,
      A: 7270,
      Iy: 162700000,
      Wely: 904000,
      Wply: 1019000,
      iy: 150,
      Iz: 10430000,
      Welz: 123000,
      Wplz: 191000,
      iz: 37.9,
      It: 373000,
      Iw: 313600000000,
      G: 57.1,
    },
    {
      nom: 'IPE 400',
      fam: 'I',
      h: 400,
      b: 180,
      tw: 8.6,
      tf: 13.5,
      r: 21,
      A: 8450,
      Iy: 231300000,
      Wely: 1156000,
      Wply: 1307000,
      iy: 165,
      Iz: 13180000,
      Welz: 146000,
      Wplz: 229000,
      iz: 39.5,
      It: 511000,
      Iw: 490000000000,
      G: 66.3,
    },
    {
      nom: 'IPE 450',
      fam: 'I',
      h: 450,
      b: 190,
      tw: 9.4,
      tf: 14.6,
      r: 21,
      A: 9880,
      Iy: 337400000,
      Wely: 1500000,
      Wply: 1702000,
      iy: 185,
      Iz: 16760000,
      Welz: 176000,
      Wplz: 276000,
      iz: 41.2,
      It: 669000,
      Iw: 791000000000,
      G: 77.6,
    },
    {
      nom: 'IPE 500',
      fam: 'I',
      h: 500,
      b: 200,
      tw: 10.2,
      tf: 16,
      r: 21,
      A: 11600,
      Iy: 482000000,
      Wely: 1928000,
      Wply: 2194000,
      iy: 204,
      Iz: 21420000,
      Welz: 214000,
      Wplz: 336000,
      iz: 43.099999999999994,
      It: 893000,
      Iw: 1249000000000,
      G: 90.7,
    },
    {
      nom: 'IPE 550',
      fam: 'I',
      h: 550,
      b: 210,
      tw: 11.1,
      tf: 17.2,
      r: 24,
      A: 13400,
      Iy: 671200000,
      Wely: 2441000,
      Wply: 2787000,
      iy: 223,
      Iz: 26680000,
      Welz: 254000,
      Wplz: 401000,
      iz: 44.5,
      It: 1230000,
      Iw: 1884000000000,
      G: 106,
    },
    {
      nom: 'IPE 600',
      fam: 'I',
      h: 600,
      b: 220,
      tw: 12,
      tf: 19,
      r: 24,
      A: 15600,
      Iy: 920800000,
      Wely: 3069000,
      Wply: 3512000,
      iy: 243,
      Iz: 33870000,
      Welz: 308000,
      Wplz: 486000,
      iz: 46.6,
      It: 1650000,
      Iw: 2846000000000,
      G: 122,
    },
    {
      nom: 'IPN 80',
      fam: 'I',
      h: 80,
      b: 42,
      tw: 3.9,
      tf: 5.9,
      r: 3.9,
      A: 757,
      Iy: 778000,
      Wely: 19500,
      Wply: 22800,
      iy: 32,
      Iz: 62900,
      Welz: 3000,
      Wplz: 5000,
      iz: 9.1,
      It: 8700,
      Iw: 87500000,
      G: 5.94,
    },
    {
      nom: 'IPN 100',
      fam: 'I',
      h: 100,
      b: 50,
      tw: 4.5,
      tf: 6.8,
      r: 4.5,
      A: 1060,
      Iy: 1710000,
      Wely: 34200,
      Wply: 39800,
      iy: 40.099999999999994,
      Iz: 122000,
      Welz: 4880,
      Wplz: 8100,
      iz: 10.700000000000001,
      It: 16000,
      Iw: 268000000,
      G: 8.34,
    },
    {
      nom: 'IPN 120',
      fam: 'I',
      h: 120,
      b: 58,
      tw: 5.1,
      tf: 7.7,
      r: 5.1,
      A: 1420,
      Iy: 3280000,
      Wely: 54700,
      Wply: 63600,
      iy: 48.099999999999994,
      Iz: 215000,
      Welz: 7410,
      Wplz: 12400,
      iz: 12.3,
      It: 27100,
      Iw: 690000000,
      G: 11.1,
    },
    {
      nom: 'IPN 140',
      fam: 'I',
      h: 140,
      b: 66,
      tw: 5.7,
      tf: 8.6,
      r: 5.7,
      A: 1830,
      Iy: 5730000,
      Wely: 81900,
      Wply: 95400,
      iy: 56.1,
      Iz: 352000,
      Welz: 10700,
      Wplz: 17900,
      iz: 14,
      It: 43200,
      Iw: 1540000000,
      G: 14.3,
    },
    {
      nom: 'IPN 160',
      fam: 'I',
      h: 160,
      b: 74,
      tw: 6.3,
      tf: 9.5,
      r: 6.3,
      A: 2280,
      Iy: 9350000,
      Wely: 117000,
      Wply: 136000,
      iy: 64,
      Iz: 547000,
      Welz: 14800,
      Wplz: 24900,
      iz: 15.5,
      It: 65700,
      Iw: 3140000000,
      G: 17.9,
    },
    {
      nom: 'IPN 180',
      fam: 'I',
      h: 180,
      b: 82,
      tw: 6.9,
      tf: 10.4,
      r: 6.9,
      A: 2790,
      Iy: 14500000,
      Wely: 161000,
      Wply: 187000,
      iy: 72,
      Iz: 813000,
      Welz: 19800,
      Wplz: 33200,
      iz: 17.1,
      It: 95800,
      Iw: 5920000000,
      G: 21.9,
    },
    {
      nom: 'IPN 200',
      fam: 'I',
      h: 200,
      b: 90,
      tw: 7.5,
      tf: 11.3,
      r: 7.5,
      A: 3340,
      Iy: 21400000,
      Wely: 214000,
      Wply: 250000,
      iy: 80,
      Iz: 1170000,
      Welz: 26000,
      Wplz: 43500,
      iz: 18.700000000000003,
      It: 135000,
      Iw: 10500000000,
      G: 26.2,
    },
    {
      nom: 'IPN 220',
      fam: 'I',
      h: 220,
      b: 98,
      tw: 8.1,
      tf: 12.2,
      r: 8.1,
      A: 3950,
      Iy: 30600000,
      Wely: 278000,
      Wply: 324000,
      iy: 88,
      Iz: 1620000,
      Welz: 33100,
      Wplz: 55700,
      iz: 20.2,
      It: 186000,
      Iw: 17800000000,
      G: 31.1,
    },
    {
      nom: 'IPN 240',
      fam: 'I',
      h: 240,
      b: 106,
      tw: 8.7,
      tf: 13.1,
      r: 8.7,
      A: 4610,
      Iy: 42500000,
      Wely: 354000,
      Wply: 412000,
      iy: 95.9,
      Iz: 2210000,
      Welz: 41700,
      Wplz: 70000,
      iz: 22,
      It: 250000,
      Iw: 28700000000,
      G: 36.2,
    },
    {
      nom: 'IPN 260',
      fam: 'I',
      h: 260,
      b: 113,
      tw: 9.4,
      tf: 14.1,
      r: 9.4,
      A: 5330,
      Iy: 57400000,
      Wely: 442000,
      Wply: 514000,
      iy: 104,
      Iz: 2880000,
      Welz: 51000,
      Wplz: 85900,
      iz: 23.2,
      It: 335000,
      Iw: 44100000000,
      G: 41.9,
    },
    {
      nom: 'IPN 280',
      fam: 'I',
      h: 280,
      b: 119,
      tw: 10.1,
      tf: 15.2,
      r: 10.1,
      A: 6100,
      Iy: 75900000,
      Wely: 542000,
      Wply: 632000,
      iy: 111,
      Iz: 3640000,
      Welz: 61200,
      Wplz: 103000,
      iz: 24.5,
      It: 442000,
      Iw: 65900000000,
      G: 47.9,
    },
    {
      nom: 'IPN 300',
      fam: 'I',
      h: 300,
      b: 125,
      tw: 10.8,
      tf: 16.2,
      r: 10.8,
      A: 6900,
      Iy: 98000000,
      Wely: 653000,
      Wply: 762000,
      iy: 119,
      Iz: 4510000,
      Welz: 72200,
      Wplz: 121000,
      iz: 25.6,
      It: 568000,
      Iw: 95200000000,
      G: 54.2,
    },
    {
      nom: 'IPN 320',
      fam: 'I',
      h: 320,
      b: 131,
      tw: 11.5,
      tf: 17.3,
      r: 11.5,
      A: 7770,
      Iy: 125100000,
      Wely: 782000,
      Wply: 914000,
      iy: 127,
      Iz: 5550000,
      Welz: 84700,
      Wplz: 143000,
      iz: 26.7,
      It: 725000,
      Iw: 136000000000,
      G: 61,
    },
    {
      nom: 'IPN 340',
      fam: 'I',
      h: 340,
      b: 137,
      tw: 12.2,
      tf: 18.3,
      r: 12.2,
      A: 8670,
      Iy: 157000000,
      Wely: 923000,
      Wply: 1080000,
      iy: 135,
      Iz: 6740000,
      Welz: 98400,
      Wplz: 166000,
      iz: 28,
      It: 904000,
      Iw: 191000000000,
      G: 68,
    },
    {
      nom: 'IPN 360',
      fam: 'I',
      h: 360,
      b: 143,
      tw: 13,
      tf: 19.5,
      r: 13,
      A: 9700,
      Iy: 196100000,
      Wely: 1090000,
      Wply: 1276000,
      iy: 142,
      Iz: 8180000,
      Welz: 114000,
      Wplz: 194000,
      iz: 29,
      It: 1150000,
      Iw: 264000000000,
      G: 76.1,
    },
    {
      nom: 'IPN 380',
      fam: 'I',
      h: 380,
      b: 149,
      tw: 13.7,
      tf: 20.5,
      r: 13.7,
      A: 10700,
      Iy: 240100000,
      Wely: 1260000,
      Wply: 1482000,
      iy: 150,
      Iz: 9750000,
      Welz: 131000,
      Wplz: 221000,
      iz: 30.2,
      It: 1410000,
      Iw: 354000000000,
      G: 84,
    },
    {
      nom: 'IPN 400',
      fam: 'I',
      h: 400,
      b: 155,
      tw: 14.4,
      tf: 21.6,
      r: 14.4,
      A: 11800,
      Iy: 292100000,
      Wely: 1460000,
      Wply: 1714000,
      iy: 157,
      Iz: 11600000,
      Welz: 149000,
      Wplz: 253000,
      iz: 31.299999999999997,
      It: 1700000,
      Iw: 470000000000,
      G: 92.4,
    },
    {
      nom: 'HEA 100',
      fam: 'H',
      h: 96,
      b: 100,
      tw: 5,
      tf: 8,
      r: 12,
      A: 2120,
      Iy: 3490000,
      Wely: 72800,
      Wply: 83000,
      iy: 40.599999999999994,
      Iz: 1340000,
      Welz: 26800,
      Wplz: 41100,
      iz: 25.099999999999998,
      It: 52400,
      Iw: 2581000000,
      G: 16.7,
    },
    {
      nom: 'HEA 120',
      fam: 'H',
      h: 114,
      b: 120,
      tw: 5,
      tf: 8,
      r: 12,
      A: 2530,
      Iy: 6060000,
      Wely: 106000,
      Wply: 119000,
      iy: 48.9,
      Iz: 2310000,
      Welz: 38500,
      Wplz: 58900,
      iz: 30.2,
      It: 59900,
      Iw: 6472000000,
      G: 19.9,
    },
    {
      nom: 'HEA 140',
      fam: 'H',
      h: 133,
      b: 140,
      tw: 5.5,
      tf: 8.5,
      r: 12,
      A: 3140,
      Iy: 10330000,
      Wely: 155000,
      Wply: 173000,
      iy: 57.300000000000004,
      Iz: 3890000,
      Welz: 55600,
      Wplz: 84800,
      iz: 35.2,
      It: 81300.00000000001,
      Iw: 15060000000,
      G: 24.7,
    },
    {
      nom: 'HEA 160',
      fam: 'H',
      h: 152,
      b: 160,
      tw: 6,
      tf: 9,
      r: 15,
      A: 3879.9999999999995,
      Iy: 16730000,
      Wely: 220000,
      Wply: 245000,
      iy: 65.7,
      Iz: 6160000,
      Welz: 76900,
      Wplz: 118000,
      iz: 39.8,
      It: 122000,
      Iw: 31410000000,
      G: 30.4,
    },
    {
      nom: 'HEA 180',
      fam: 'H',
      h: 171,
      b: 180,
      tw: 6,
      tf: 9.5,
      r: 15,
      A: 4530,
      Iy: 25100000,
      Wely: 294000,
      Wply: 325000,
      iy: 74.5,
      Iz: 9250000,
      Welz: 103000,
      Wplz: 156000,
      iz: 45.199999999999996,
      It: 148000,
      Iw: 60210000000,
      G: 35.5,
    },
    {
      nom: 'HEA 200',
      fam: 'H',
      h: 190,
      b: 200,
      tw: 6.5,
      tf: 10,
      r: 18,
      A: 5380,
      Iy: 36920000,
      Wely: 389000,
      Wply: 430000,
      iy: 82.8,
      Iz: 13360000,
      Welz: 134000,
      Wplz: 204000,
      iz: 49.800000000000004,
      It: 210000,
      Iw: 108000000000,
      G: 42.3,
    },
    {
      nom: 'HEA 220',
      fam: 'H',
      h: 210,
      b: 220,
      tw: 7,
      tf: 11,
      r: 18,
      A: 6430,
      Iy: 54100000,
      Wely: 515000,
      Wply: 568000,
      iy: 91.7,
      Iz: 19550000,
      Welz: 178000,
      Wplz: 271000,
      iz: 55.099999999999994,
      It: 285000,
      Iw: 193300000000,
      G: 50.5,
    },
    {
      nom: 'HEA 240',
      fam: 'H',
      h: 230,
      b: 240,
      tw: 7.5,
      tf: 12,
      r: 21,
      A: 7680,
      Iy: 77630000,
      Wely: 675000,
      Wply: 745000,
      iy: 101,
      Iz: 27690000,
      Welz: 231000,
      Wplz: 352000,
      iz: 60,
      It: 416000,
      Iw: 328500000000,
      G: 60.3,
    },
    {
      nom: 'HEA 260',
      fam: 'H',
      h: 250,
      b: 260,
      tw: 7.5,
      tf: 12.5,
      r: 24,
      A: 8680,
      Iy: 104500000,
      Wely: 836000,
      Wply: 920000,
      iy: 110,
      Iz: 36680000,
      Welz: 282000,
      Wplz: 430000,
      iz: 65,
      It: 524000,
      Iw: 516400000000,
      G: 68.2,
    },
    {
      nom: 'HEA 280',
      fam: 'H',
      h: 270,
      b: 280,
      tw: 8,
      tf: 13,
      r: 24,
      A: 9730,
      Iy: 136700000,
      Wely: 1013000,
      Wply: 1112000,
      iy: 119,
      Iz: 47630000,
      Welz: 340000,
      Wplz: 518000,
      iz: 70,
      It: 621000,
      Iw: 785400000000,
      G: 76.4,
    },
    {
      nom: 'HEA 300',
      fam: 'H',
      h: 290,
      b: 300,
      tw: 8.5,
      tf: 14,
      r: 27,
      A: 11250,
      Iy: 182600000,
      Wely: 1260000,
      Wply: 1383000,
      iy: 127,
      Iz: 63100000,
      Welz: 421000,
      Wplz: 641000,
      iz: 74.9,
      It: 852000,
      Iw: 1200000000000,
      G: 88.3,
    },
    {
      nom: 'HEA 320',
      fam: 'H',
      h: 310,
      b: 300,
      tw: 9,
      tf: 15.5,
      r: 27,
      A: 12440,
      Iy: 229300000,
      Wely: 1479000,
      Wply: 1628000,
      iy: 136,
      Iz: 69850000,
      Welz: 466000,
      Wplz: 710000,
      iz: 74.9,
      It: 1080000,
      Iw: 1512000000000,
      G: 97.6,
    },
    {
      nom: 'HEA 340',
      fam: 'H',
      h: 330,
      b: 300,
      tw: 9.5,
      tf: 16.5,
      r: 27,
      A: 13350,
      Iy: 276900000,
      Wely: 1678000,
      Wply: 1850000,
      iy: 144,
      Iz: 74360000,
      Welz: 496000,
      Wplz: 756000,
      iz: 74.6,
      It: 1270000,
      Iw: 1824000000000,
      G: 105,
    },
    {
      nom: 'HEA 360',
      fam: 'H',
      h: 350,
      b: 300,
      tw: 10,
      tf: 17.5,
      r: 27,
      A: 14280.000000000002,
      Iy: 330900000,
      Wely: 1891000,
      Wply: 2088000,
      iy: 152,
      Iz: 78870000,
      Welz: 526000,
      Wplz: 802000,
      iz: 74.3,
      It: 1490000,
      Iw: 2177000000000,
      G: 112,
    },
    {
      nom: 'HEA 400',
      fam: 'H',
      h: 390,
      b: 300,
      tw: 11,
      tf: 19,
      r: 27,
      A: 15900,
      Iy: 450700000,
      Wely: 2311000,
      Wply: 2562000,
      iy: 168,
      Iz: 85640000,
      Welz: 571000,
      Wplz: 873000,
      iz: 73.4,
      It: 1890000,
      Iw: 2942000000000,
      G: 125,
    },
    {
      nom: 'HEA 450',
      fam: 'H',
      h: 440,
      b: 300,
      tw: 11.5,
      tf: 21,
      r: 27,
      A: 17800,
      Iy: 637200000,
      Wely: 2896000,
      Wply: 3216000,
      iy: 189,
      Iz: 94650000,
      Welz: 631000,
      Wplz: 966000,
      iz: 72.9,
      It: 2440000,
      Iw: 4148000000000,
      G: 140,
    },
    {
      nom: 'HEA 500',
      fam: 'H',
      h: 490,
      b: 300,
      tw: 12,
      tf: 23,
      r: 27,
      A: 19750,
      Iy: 869700000,
      Wely: 3550000,
      Wply: 3949000,
      iy: 210,
      Iz: 103700000,
      Welz: 691000,
      Wplz: 1059000,
      iz: 72.4,
      It: 3090000,
      Iw: 5643000000000,
      G: 155,
    },
    {
      nom: 'HEA 550',
      fam: 'H',
      h: 540,
      b: 300,
      tw: 12.5,
      tf: 24,
      r: 27,
      A: 21180,
      Iy: 1119000000,
      Wely: 4146000,
      Wply: 4622000,
      iy: 230,
      Iz: 108200000,
      Welz: 721300,
      Wplz: 1107000,
      iz: 71.5,
      It: 3515000,
      Iw: 7189000000000,
      G: 166,
    },
    {
      nom: 'HEA 600',
      fam: 'H',
      h: 590,
      b: 300,
      tw: 13,
      tf: 25,
      r: 27,
      A: 22650,
      Iy: 1412000000,
      Wely: 4787000,
      Wply: 5350000,
      iy: 250,
      Iz: 112700000,
      Welz: 751400,
      Wplz: 1156000,
      iz: 70.5,
      It: 3978000,
      Iw: 8978000000000,
      G: 178,
    },
    {
      nom: 'HEA 650',
      fam: 'H',
      h: 640,
      b: 300,
      tw: 13.5,
      tf: 26,
      r: 27,
      A: 24160,
      Iy: 1752000000,
      Wely: 5474000,
      Wply: 6136000,
      iy: 269,
      Iz: 117200000,
      Welz: 781600,
      Wplz: 1205000,
      iz: 69.7,
      It: 4483000,
      Iw: 11030000000000,
      G: 190,
    },
    {
      nom: 'HEA 700',
      fam: 'H',
      h: 690,
      b: 300,
      tw: 14.5,
      tf: 27,
      r: 27,
      A: 26050,
      Iy: 2153000000,
      Wely: 6241000,
      Wply: 7032000,
      iy: 288,
      Iz: 121800000,
      Welz: 811900,
      Wplz: 1257000,
      iz: 68.4,
      It: 5139000,
      Iw: 13350000000000,
      G: 204,
    },
    {
      nom: 'HEA 800',
      fam: 'H',
      h: 790,
      b: 300,
      tw: 15,
      tf: 28,
      r: 30,
      A: 28580,
      Iy: 3034000000,
      Wely: 7682000,
      Wply: 8699000,
      iy: 326,
      Iz: 126400000,
      Welz: 842600,
      Wplz: 1312000,
      iz: 66.5,
      It: 5970000,
      Iw: 18290000000000,
      G: 224,
    },
    {
      nom: 'HEA 900',
      fam: 'H',
      h: 890,
      b: 300,
      tw: 16,
      tf: 30,
      r: 30,
      A: 32050,
      Iy: 4221000000,
      Wely: 9485000,
      Wply: 10810000,
      iy: 363,
      Iz: 135500000,
      Welz: 903200,
      Wplz: 1414000,
      iz: 65,
      It: 7372000,
      Iw: 25790000000000,
      G: 252,
    },
    {
      nom: 'HEA 1000',
      fam: 'H',
      h: 990,
      b: 300,
      tw: 16.5,
      tf: 31,
      r: 30,
      A: 34680,
      Iy: 5538000000,
      Wely: 11190000,
      Wply: 12820000,
      iy: 400,
      Iz: 140000000,
      Welz: 933600,
      Wplz: 1470000,
      iz: 63.5,
      It: 8224000,
      Iw: 32970000000000,
      G: 272,
    },
    {
      nom: 'HEB 100',
      fam: 'H',
      h: 100,
      b: 100,
      tw: 6,
      tf: 10,
      r: 12,
      A: 2600,
      Iy: 4500000,
      Wely: 89900,
      Wply: 104000,
      iy: 41.6,
      Iz: 1670000,
      Welz: 33500,
      Wplz: 51400,
      iz: 25.299999999999997,
      It: 92500,
      Iw: 3375000000,
      G: 20.4,
    },
    {
      nom: 'HEB 120',
      fam: 'H',
      h: 120,
      b: 120,
      tw: 6.5,
      tf: 11,
      r: 12,
      A: 3400,
      Iy: 8640000,
      Wely: 144000,
      Wply: 165000,
      iy: 50.4,
      Iz: 3180000,
      Welz: 52900,
      Wplz: 81000,
      iz: 30.6,
      It: 138000,
      Iw: 9410000000,
      G: 26.7,
    },
    {
      nom: 'HEB 140',
      fam: 'H',
      h: 140,
      b: 140,
      tw: 7,
      tf: 12,
      r: 12,
      A: 4300,
      Iy: 15090000,
      Wely: 216000,
      Wply: 245000,
      iy: 59.3,
      Iz: 5500000,
      Welz: 78500,
      Wplz: 120000,
      iz: 35.8,
      It: 201000,
      Iw: 22480000000,
      G: 33.7,
    },
    {
      nom: 'HEB 160',
      fam: 'H',
      h: 160,
      b: 160,
      tw: 8,
      tf: 13,
      r: 15,
      A: 5430,
      Iy: 24920000,
      Wely: 311000,
      Wply: 354000,
      iy: 67.8,
      Iz: 8890000,
      Welz: 111000,
      Wplz: 170000,
      iz: 40.5,
      It: 312000,
      Iw: 47940000000,
      G: 42.6,
    },
    {
      nom: 'HEB 180',
      fam: 'H',
      h: 180,
      b: 180,
      tw: 8.5,
      tf: 14,
      r: 15,
      A: 6530,
      Iy: 38310000,
      Wely: 426000,
      Wply: 481000,
      iy: 76.6,
      Iz: 13630000,
      Welz: 151000,
      Wplz: 231000,
      iz: 45.7,
      It: 422000,
      Iw: 93750000000,
      G: 51.2,
    },
    {
      nom: 'HEB 200',
      fam: 'H',
      h: 200,
      b: 200,
      tw: 9,
      tf: 15,
      r: 18,
      A: 7809.999999999999,
      Iy: 56960000,
      Wely: 570000,
      Wply: 643000,
      iy: 85.39999999999999,
      Iz: 20030000,
      Welz: 200000,
      Wplz: 306000,
      iz: 50.7,
      It: 593000,
      Iw: 171100000000,
      G: 61.3,
    },
    {
      nom: 'HEB 220',
      fam: 'H',
      h: 220,
      b: 220,
      tw: 9.5,
      tf: 16,
      r: 18,
      A: 9100,
      Iy: 80910000,
      Wely: 736000,
      Wply: 827000,
      iy: 94.3,
      Iz: 28430000,
      Welz: 258000,
      Wplz: 394000,
      iz: 55.9,
      It: 766000,
      Iw: 295400000000,
      G: 71.5,
    },
    {
      nom: 'HEB 240',
      fam: 'H',
      h: 240,
      b: 240,
      tw: 10,
      tf: 17,
      r: 21,
      A: 10600,
      Iy: 112600000,
      Wely: 938000,
      Wply: 1053000,
      iy: 103,
      Iz: 39230000,
      Welz: 327000,
      Wplz: 498000,
      iz: 60.8,
      It: 1030000,
      Iw: 486900000000,
      G: 83.2,
    },
    {
      nom: 'HEB 260',
      fam: 'H',
      h: 260,
      b: 260,
      tw: 10,
      tf: 17.5,
      r: 24,
      A: 11840,
      Iy: 149200000,
      Wely: 1148000,
      Wply: 1283000,
      iy: 112,
      Iz: 51350000,
      Welz: 395000,
      Wplz: 602000,
      iz: 65.8,
      It: 1240000,
      Iw: 753700000000,
      G: 93,
    },
    {
      nom: 'HEB 280',
      fam: 'H',
      h: 280,
      b: 280,
      tw: 10.5,
      tf: 18,
      r: 24,
      A: 13140,
      Iy: 192700000,
      Wely: 1376000,
      Wply: 1534000,
      iy: 121,
      Iz: 65950000,
      Welz: 471000,
      Wplz: 718000,
      iz: 70.9,
      It: 1440000,
      Iw: 1130000000000,
      G: 103,
    },
    {
      nom: 'HEB 300',
      fam: 'H',
      h: 300,
      b: 300,
      tw: 11,
      tf: 19,
      r: 27,
      A: 14910,
      Iy: 251700000,
      Wely: 1678000,
      Wply: 1869000,
      iy: 130,
      Iz: 85630000,
      Welz: 571000,
      Wplz: 870000,
      iz: 75.8,
      It: 1850000,
      Iw: 1688000000000,
      G: 117,
    },
    {
      nom: 'HEB 320',
      fam: 'H',
      h: 320,
      b: 300,
      tw: 11.5,
      tf: 20.5,
      r: 27,
      A: 16130.000000000002,
      Iy: 308200000,
      Wely: 1926000,
      Wply: 2149000,
      iy: 138,
      Iz: 92390000,
      Welz: 616000,
      Wplz: 939000,
      iz: 75.7,
      It: 2250000,
      Iw: 2069000000000,
      G: 127,
    },
    {
      nom: 'HEB 340',
      fam: 'H',
      h: 340,
      b: 300,
      tw: 12,
      tf: 21.5,
      r: 27,
      A: 17090,
      Iy: 366600000,
      Wely: 2156000,
      Wply: 2408000,
      iy: 146,
      Iz: 96900000,
      Welz: 646000,
      Wplz: 986000,
      iz: 75.3,
      It: 2570000,
      Iw: 2454000000000,
      G: 134,
    },
    {
      nom: 'HEB 360',
      fam: 'H',
      h: 360,
      b: 300,
      tw: 12.5,
      tf: 22.5,
      r: 27,
      A: 18060,
      Iy: 431900000,
      Wely: 2400000,
      Wply: 2683000,
      iy: 155,
      Iz: 101400000,
      Welz: 676000,
      Wplz: 1032000,
      iz: 74.9,
      It: 2920000,
      Iw: 2883000000000,
      G: 142,
    },
    {
      nom: 'HEB 400',
      fam: 'H',
      h: 400,
      b: 300,
      tw: 13.5,
      tf: 24,
      r: 27,
      A: 19780,
      Iy: 576800000,
      Wely: 2884000,
      Wply: 3232000,
      iy: 171,
      Iz: 108200000,
      Welz: 721000,
      Wplz: 1104000,
      iz: 74,
      It: 3560000,
      Iw: 3817000000000,
      G: 155,
    },
    {
      nom: 'HEB 450',
      fam: 'H',
      h: 450,
      b: 300,
      tw: 14,
      tf: 26,
      r: 27,
      A: 21800,
      Iy: 798900000,
      Wely: 3551000,
      Wply: 3982000,
      iy: 191,
      Iz: 117200000,
      Welz: 781000,
      Wplz: 1198000,
      iz: 73.3,
      It: 4400000,
      Iw: 5258000000000,
      G: 171,
    },
    {
      nom: 'HEB 500',
      fam: 'H',
      h: 500,
      b: 300,
      tw: 14.5,
      tf: 28,
      r: 27,
      A: 23860,
      Iy: 1072000000,
      Wely: 4287000,
      Wply: 4815000,
      iy: 212,
      Iz: 126200000,
      Welz: 842000,
      Wplz: 1292000,
      iz: 72.69999999999999,
      It: 5380000,
      Iw: 7018000000000,
      G: 187,
    },
    {
      nom: 'HEB 550',
      fam: 'H',
      h: 550,
      b: 300,
      tw: 15,
      tf: 29,
      r: 27,
      A: 25410,
      Iy: 1367000000,
      Wely: 4971000,
      Wply: 5591000,
      iy: 232,
      Iz: 130800000,
      Welz: 871800,
      Wplz: 1341000,
      iz: 71.7,
      It: 6003000,
      Iw: 8856000000000,
      G: 199,
    },
    {
      nom: 'HEB 600',
      fam: 'H',
      h: 600,
      b: 300,
      tw: 15.5,
      tf: 30,
      r: 27,
      A: 27000,
      Iy: 1710000000,
      Wely: 5701000,
      Wply: 6425000,
      iy: 252,
      Iz: 135300000,
      Welz: 902000,
      Wplz: 1391000,
      iz: 70.8,
      It: 6672000,
      Iw: 10970000000000,
      G: 212,
    },
    {
      nom: 'HEB 650',
      fam: 'H',
      h: 650,
      b: 300,
      tw: 16,
      tf: 31,
      r: 27,
      A: 28630,
      Iy: 2106000000,
      Wely: 6480000,
      Wply: 7320000,
      iy: 271,
      Iz: 139800000,
      Welz: 932300,
      Wplz: 1441000,
      iz: 69.9,
      It: 7392000,
      Iw: 13360000000000,
      G: 225,
    },
    {
      nom: 'HEB 700',
      fam: 'H',
      h: 700,
      b: 300,
      tw: 17,
      tf: 32,
      r: 27,
      A: 30639.999999999996,
      Iy: 2569000000,
      Wely: 7340000,
      Wply: 8327000,
      iy: 290,
      Iz: 144400000,
      Welz: 962700,
      Wplz: 1495000,
      iz: 68.7,
      It: 8309000,
      Iw: 16060000000000,
      G: 241,
    },
    {
      nom: 'HEB 800',
      fam: 'H',
      h: 800,
      b: 300,
      tw: 17.5,
      tf: 33,
      r: 30,
      A: 33420,
      Iy: 3591000000,
      Wely: 8977000,
      Wply: 10230000,
      iy: 328,
      Iz: 149000000,
      Welz: 993600,
      Wplz: 1553000,
      iz: 66.8,
      It: 9460000,
      Iw: 21840000000000,
      G: 262,
    },
    {
      nom: 'HEB 900',
      fam: 'H',
      h: 900,
      b: 300,
      tw: 18.5,
      tf: 35,
      r: 30,
      A: 37130,
      Iy: 4941000000,
      Wely: 10980000,
      Wply: 12580000,
      iy: 365,
      Iz: 158200000,
      Welz: 1054000,
      Wplz: 1658000,
      iz: 65.3,
      It: 11370000,
      Iw: 30490000000000,
      G: 291,
    },
    {
      nom: 'HEB 1000',
      fam: 'H',
      h: 1000,
      b: 300,
      tw: 19,
      tf: 36,
      r: 30,
      A: 40000,
      Iy: 6447000000,
      Wely: 12890000,
      Wply: 14860000,
      iy: 402,
      Iz: 162800000,
      Welz: 1085000,
      Wplz: 1716000,
      iz: 63.8,
      It: 12540000,
      Iw: 38870000000000,
      G: 314,
    },
    {
      nom: 'HEM 100',
      fam: 'H',
      h: 120,
      b: 106,
      tw: 12,
      tf: 20,
      r: 12,
      A: 5320,
      Iy: 11430000,
      Wely: 190400,
      Wply: 235800,
      iy: 46.3,
      Iz: 3992000,
      Welz: 75300,
      Wplz: 116300,
      iz: 27.400000000000002,
      It: 682000,
      Iw: 9925000000,
      G: 41.8,
    },
    {
      nom: 'HEM 120',
      fam: 'H',
      h: 140,
      b: 126,
      tw: 12.5,
      tf: 21,
      r: 12,
      A: 6640.000000000001,
      Iy: 20180000,
      Wely: 288200,
      Wply: 350600,
      iy: 55.099999999999994,
      Iz: 7028000,
      Welz: 111600,
      Wplz: 171600,
      iz: 32.5,
      It: 917000,
      Iw: 24790000000,
      G: 52.1,
    },
    {
      nom: 'HEM 140',
      fam: 'H',
      h: 160,
      b: 146,
      tw: 13,
      tf: 22,
      r: 12,
      A: 8059.999999999999,
      Iy: 32910000,
      Wely: 411400,
      Wply: 493800,
      iy: 63.9,
      Iz: 11440000,
      Welz: 156800,
      Wplz: 240500,
      iz: 37.7,
      It: 1200000,
      Iw: 54330000000,
      G: 63.2,
    },
    {
      nom: 'HEM 160',
      fam: 'H',
      h: 180,
      b: 166,
      tw: 14,
      tf: 23,
      r: 15,
      A: 9710,
      Iy: 50980000,
      Wely: 566500,
      Wply: 674600,
      iy: 72.5,
      Iz: 17590000,
      Welz: 211900,
      Wplz: 325500,
      iz: 42.599999999999994,
      It: 1624000,
      Iw: 108100000000,
      G: 76.2,
    },
    {
      nom: 'HEM 180',
      fam: 'H',
      h: 200,
      b: 186,
      tw: 14.5,
      tf: 24,
      r: 15,
      A: 11330,
      Iy: 74830000,
      Wely: 748300,
      Wply: 883400,
      iy: 81.30000000000001,
      Iz: 25800000,
      Welz: 277400,
      Wplz: 425200,
      iz: 47.699999999999996,
      It: 2033000,
      Iw: 199300000000,
      G: 88.9,
    },
    {
      nom: 'HEM 200',
      fam: 'H',
      h: 220,
      b: 206,
      tw: 15,
      tf: 25,
      r: 18,
      A: 13130.000000000002,
      Iy: 106400000,
      Wely: 967400,
      Wply: 1135000,
      iy: 90,
      Iz: 36510000,
      Welz: 354500,
      Wplz: 543200,
      iz: 52.699999999999996,
      It: 2594000,
      Iw: 346300000000,
      G: 103,
    },
    {
      nom: 'HEM 220',
      fam: 'H',
      h: 240,
      b: 226,
      tw: 15.5,
      tf: 26,
      r: 18,
      A: 14940,
      Iy: 146000000,
      Wely: 1217000,
      Wply: 1419000,
      iy: 98.9,
      Iz: 50120000,
      Welz: 443500,
      Wplz: 678600,
      iz: 57.9,
      It: 3153000,
      Iw: 572700000000,
      G: 117,
    },
    {
      nom: 'HEM 240',
      fam: 'H',
      h: 270,
      b: 248,
      tw: 18,
      tf: 32,
      r: 21,
      A: 19960,
      Iy: 242900000,
      Wely: 1799000,
      Wply: 2117000,
      iy: 110,
      Iz: 81530000,
      Welz: 657500,
      Wplz: 1006000,
      iz: 63.9,
      It: 6279000,
      Iw: 1152000000000,
      G: 157,
    },
    {
      nom: 'HEM 260',
      fam: 'H',
      h: 290,
      b: 268,
      tw: 18,
      tf: 32.5,
      r: 24,
      A: 21960,
      Iy: 313100000,
      Wely: 2159000,
      Wply: 2524000,
      iy: 119,
      Iz: 104500000,
      Welz: 779700,
      Wplz: 1192000,
      iz: 69,
      It: 7190000,
      Iw: 1728000000000,
      G: 172,
    },
    {
      nom: 'HEM 280',
      fam: 'H',
      h: 310,
      b: 288,
      tw: 18.5,
      tf: 33,
      r: 24,
      A: 24020,
      Iy: 395500000,
      Wely: 2551000,
      Wply: 2966000,
      iy: 128,
      Iz: 131600000,
      Welz: 914100,
      Wplz: 1397000,
      iz: 74,
      It: 8073000,
      Iw: 2520000000000,
      G: 189,
    },
    {
      nom: 'HEM 300',
      fam: 'H',
      h: 340,
      b: 310,
      tw: 21,
      tf: 39,
      r: 27,
      A: 30310.000000000004,
      Iy: 592000000,
      Wely: 3482000,
      Wply: 4078000,
      iy: 140,
      Iz: 194000000,
      Welz: 1252000,
      Wplz: 1913000,
      iz: 80,
      It: 14080000,
      Iw: 4386000000000,
      G: 238,
    },
    {
      nom: 'HEM 320',
      fam: 'H',
      h: 359,
      b: 309,
      tw: 21,
      tf: 40,
      r: 27,
      A: 31200,
      Iy: 681300000,
      Wely: 3796000,
      Wply: 4435000,
      iy: 148,
      Iz: 197100000,
      Welz: 1276000,
      Wplz: 1951000,
      iz: 79.5,
      It: 15010000,
      Iw: 5004000000000,
      G: 245,
    },
    {
      nom: 'HEM 340',
      fam: 'H',
      h: 377,
      b: 309,
      tw: 21,
      tf: 40,
      r: 27,
      A: 31580,
      Iy: 763700000,
      Wely: 4052000,
      Wply: 4718000,
      iy: 156,
      Iz: 197100000,
      Welz: 1276000,
      Wplz: 1953000,
      iz: 79,
      It: 15060000,
      Iw: 5584000000000,
      G: 248,
    },
    {
      nom: 'HEM 360',
      fam: 'H',
      h: 395,
      b: 308,
      tw: 21,
      tf: 40,
      r: 27,
      A: 31880,
      Iy: 848700000,
      Wely: 4297000,
      Wply: 4989000,
      iy: 163,
      Iz: 195200000,
      Welz: 1268000,
      Wplz: 1942000,
      iz: 78.3,
      It: 15070000,
      Iw: 6137000000000,
      G: 250,
    },
    {
      nom: 'HEM 400',
      fam: 'H',
      h: 432,
      b: 307,
      tw: 21,
      tf: 40,
      r: 27,
      A: 32580,
      Iy: 1041000000,
      Wely: 4820000,
      Wply: 5571000,
      iy: 179,
      Iz: 193400000,
      Welz: 1260000,
      Wplz: 1934000,
      iz: 77,
      It: 15150000,
      Iw: 7410000000000,
      G: 256,
    },
    {
      nom: 'HEM 450',
      fam: 'H',
      h: 478,
      b: 307,
      tw: 21,
      tf: 40,
      r: 27,
      A: 33540,
      Iy: 1315000000,
      Wely: 5501000,
      Wply: 6331000,
      iy: 198,
      Iz: 193400000,
      Welz: 1260000,
      Wplz: 1939000,
      iz: 75.9,
      It: 15290000,
      Iw: 9251000000000,
      G: 263,
    },
    {
      nom: 'HEM 500',
      fam: 'H',
      h: 524,
      b: 306,
      tw: 21,
      tf: 40,
      r: 27,
      A: 34430,
      Iy: 1619000000,
      Wely: 6180000,
      Wply: 7094000,
      iy: 217,
      Iz: 191500000,
      Welz: 1252000,
      Wplz: 1932000,
      iz: 74.6,
      It: 15390000,
      Iw: 11190000000000,
      G: 270,
    },
    {
      nom: 'HEM 550',
      fam: 'H',
      h: 572,
      b: 306,
      tw: 21,
      tf: 40,
      r: 27,
      A: 35440,
      Iy: 1980000000,
      Wely: 6923000,
      Wply: 7933000,
      iy: 236,
      Iz: 191600000,
      Welz: 1252000,
      Wplz: 1937000,
      iz: 73.5,
      It: 15540000,
      Iw: 13520000000000,
      G: 278,
    },
    {
      nom: 'HEM 600',
      fam: 'H',
      h: 620,
      b: 305,
      tw: 21,
      tf: 40,
      r: 27,
      A: 36370,
      Iy: 2374000000,
      Wely: 7660000,
      Wply: 8772000,
      iy: 256,
      Iz: 189800000,
      Welz: 1244000,
      Wplz: 1930000,
      iz: 72.2,
      It: 15640000,
      Iw: 16060000000000,
      G: 285,
    },
    {
      nom: 'HEM 650',
      fam: 'H',
      h: 668,
      b: 305,
      tw: 21,
      tf: 40,
      r: 27,
      A: 37370,
      Iy: 2817000000,
      Wely: 8433000,
      Wply: 9657000,
      iy: 275,
      Iz: 189800000,
      Welz: 1245000,
      Wplz: 1936000,
      iz: 71.3,
      It: 15800000,
      Iw: 18930000000000,
      G: 293,
    },
    {
      nom: 'HEM 700',
      fam: 'H',
      h: 716,
      b: 304,
      tw: 21,
      tf: 40,
      r: 27,
      A: 38300,
      Iy: 3293000000,
      Wely: 9198000,
      Wply: 10540000,
      iy: 293,
      Iz: 188000000,
      Welz: 1237000,
      Wplz: 1929000,
      iz: 70.1,
      It: 15890000,
      Iw: 21920000000000,
      G: 301,
    },
    {
      nom: 'HEM 800',
      fam: 'H',
      h: 814,
      b: 303,
      tw: 21,
      tf: 40,
      r: 30,
      A: 40430,
      Iy: 4426000000,
      Wely: 10870000,
      Wply: 12490000,
      iy: 331,
      Iz: 186300000,
      Welz: 1230000,
      Wplz: 1930000,
      iz: 67.9,
      It: 16460000,
      Iw: 28850000000000,
      G: 317,
    },
    {
      nom: 'HEM 900',
      fam: 'H',
      h: 910,
      b: 302,
      tw: 21,
      tf: 40,
      r: 30,
      A: 42360,
      Iy: 5704000000,
      Wely: 12540000,
      Wply: 14440000,
      iy: 367,
      Iz: 184500000,
      Welz: 1222000,
      Wplz: 1929000,
      iz: 66,
      It: 16710000,
      Iw: 36400000000000,
      G: 333,
    },
    {
      nom: 'HEM 1000',
      fam: 'H',
      h: 1008,
      b: 302,
      tw: 21,
      tf: 40,
      r: 30,
      A: 44420,
      Iy: 7223000000,
      Wely: 14330000,
      Wply: 16570000,
      iy: 403,
      Iz: 184600000,
      Welz: 1222000,
      Wplz: 1940000,
      iz: 64.5,
      It: 17010000,
      Iw: 45150000000000,
      G: 349,
    },
    {
      nom: 'UPE 80',
      fam: 'U',
      h: 80,
      b: 50,
      tw: 4,
      tf: 7,
      r: 10,
      A: 1010,
      Iy: 1072000,
      Wely: 26800,
      Wply: 31200,
      iy: 32.599999999999994,
      Iz: 255000,
      Welz: 7300,
      Wplz: 13600,
      iz: 15.9,
      It: 16000,
      Iw: 257000000,
      G: 7.9,
    },
    {
      nom: 'UPE 100',
      fam: 'U',
      h: 100,
      b: 55,
      tw: 4.5,
      tf: 7.5,
      r: 10,
      A: 1250,
      Iy: 2070000,
      Wely: 41400,
      Wply: 48000,
      iy: 40.7,
      Iz: 383000,
      Welz: 9750,
      Wplz: 18200,
      iz: 17.5,
      It: 20099.999999999996,
      Iw: 644000000,
      G: 9.82,
    },
    {
      nom: 'UPE 120',
      fam: 'U',
      h: 120,
      b: 60,
      tw: 5,
      tf: 8,
      r: 12,
      A: 1540,
      Iy: 3640000,
      Wely: 60600,
      Wply: 70300,
      iy: 48.6,
      Iz: 555000,
      Welz: 12900,
      Wplz: 24200,
      iz: 19,
      It: 29000,
      Iw: 1354000000,
      G: 12.1,
    },
    {
      nom: 'UPE 140',
      fam: 'U',
      h: 140,
      b: 65,
      tw: 5,
      tf: 9,
      r: 12,
      A: 1839.9999999999998,
      Iy: 6000000,
      Wely: 85600,
      Wply: 98800,
      iy: 57.1,
      Iz: 788000,
      Welz: 16800,
      Wplz: 31500,
      iz: 20.7,
      It: 42100,
      Iw: 2585000000,
      G: 14.5,
    },
    {
      nom: 'UPE 160',
      fam: 'U',
      h: 160,
      b: 70,
      tw: 5.5,
      tf: 9.5,
      r: 12,
      A: 2170,
      Iy: 9110000,
      Wely: 114000,
      Wply: 132000,
      iy: 64.80000000000001,
      Iz: 1070000,
      Welz: 21000,
      Wplz: 39400,
      iz: 22.200000000000003,
      It: 55100,
      Iw: 4664000000,
      G: 17,
    },
    {
      nom: 'UPE 180',
      fam: 'U',
      h: 180,
      b: 75,
      tw: 5.5,
      tf: 10.5,
      r: 12,
      A: 2510,
      Iy: 13500000,
      Wely: 150000,
      Wply: 173000,
      iy: 73.4,
      Iz: 1440000,
      Welz: 25500,
      Wplz: 47900,
      iz: 24,
      It: 78600,
      Iw: 7857000000,
      G: 19.7,
    },
    {
      nom: 'UPE 200',
      fam: 'U',
      h: 200,
      b: 80,
      tw: 6,
      tf: 11,
      r: 13,
      A: 2900,
      Iy: 19100000,
      Wely: 191000,
      Wply: 220000,
      iy: 81.19999999999999,
      Iz: 1870000,
      Welz: 31000,
      Wplz: 58100,
      iz: 25.4,
      It: 101000,
      Iw: 12690000000,
      G: 22.8,
    },
    {
      nom: 'UPE 220',
      fam: 'U',
      h: 220,
      b: 85,
      tw: 6.5,
      tf: 12,
      r: 13,
      A: 3390,
      Iy: 26800000,
      Wely: 244000,
      Wply: 281000,
      iy: 89,
      Iz: 2460000,
      Welz: 38400,
      Wplz: 71900,
      iz: 27,
      It: 145000,
      Iw: 20360000000,
      G: 26.6,
    },
    {
      nom: 'UPE 240',
      fam: 'U',
      h: 240,
      b: 90,
      tw: 7,
      tf: 12.5,
      r: 15,
      A: 3850,
      Iy: 36000000,
      Wely: 300000,
      Wply: 346000,
      iy: 96.7,
      Iz: 3110000,
      Welz: 45900,
      Wplz: 86400,
      iz: 28.4,
      It: 184000,
      Iw: 31090000000,
      G: 30.2,
    },
    {
      nom: 'UPE 270',
      fam: 'U',
      h: 270,
      b: 95,
      tw: 7.5,
      tf: 13.5,
      r: 15,
      A: 4480,
      Iy: 52500000,
      Wely: 389000,
      Wply: 448000,
      iy: 108,
      Iz: 4010000,
      Welz: 55900,
      Wplz: 105000,
      iz: 29.900000000000002,
      It: 249000,
      Iw: 54680000000,
      G: 35.2,
    },
    {
      nom: 'UPE 300',
      fam: 'U',
      h: 300,
      b: 100,
      tw: 9.5,
      tf: 15,
      r: 15,
      A: 5660,
      Iy: 78200000,
      Wely: 521000,
      Wply: 612000,
      iy: 118,
      Iz: 5370000,
      Welz: 70600,
      Wplz: 134000,
      iz: 30.8,
      It: 415000,
      Iw: 89600000000,
      G: 44.4,
    },
    {
      nom: 'UPE 330',
      fam: 'U',
      h: 330,
      b: 105,
      tw: 11,
      tf: 16,
      r: 18,
      A: 6790.000000000001,
      Iy: 110100000,
      Wely: 667000,
      Wply: 791000,
      iy: 127,
      Iz: 6810000,
      Welz: 85800,
      Wplz: 164000,
      iz: 31.7,
      It: 634000,
      Iw: 141500000000,
      G: 53.2,
    },
    {
      nom: 'UPE 360',
      fam: 'U',
      h: 360,
      b: 110,
      tw: 12,
      tf: 17,
      r: 18,
      A: 7790.000000000001,
      Iy: 148300000,
      Wely: 824000,
      Wply: 980000,
      iy: 138,
      Iz: 8440000,
      Welz: 102000,
      Wplz: 196000,
      iz: 32.9,
      It: 844000,
      Iw: 214100000000,
      G: 61.2,
    },
    {
      nom: 'UPE 400',
      fam: 'U',
      h: 400,
      b: 115,
      tw: 13.5,
      tf: 18,
      r: 18,
      A: 9190,
      Iy: 209800000,
      Wely: 1049000,
      Wply: 1256000,
      iy: 151,
      Iz: 10450000,
      Welz: 121000,
      Wplz: 234000,
      iz: 33.7,
      It: 1190000,
      Iw: 340500000000,
      G: 72.2,
    },
    {
      nom: 'UPN 80',
      fam: 'U',
      h: 80,
      b: 45,
      tw: 6,
      tf: 8,
      r: 8,
      A: 1100,
      Iy: 1060000,
      Wely: 26500,
      Wply: 31800,
      iy: 31,
      Iz: 194000,
      Welz: 6360,
      Wplz: 12100,
      iz: 13.3,
      It: 21600,
      Iw: 194000000,
      G: 8.64,
    },
    {
      nom: 'UPN 100',
      fam: 'U',
      h: 100,
      b: 50,
      tw: 6,
      tf: 8.5,
      r: 8.5,
      A: 1350,
      Iy: 2060000,
      Wely: 41200,
      Wply: 49000,
      iy: 39.1,
      Iz: 293000,
      Welz: 8490,
      Wplz: 16200,
      iz: 14.7,
      It: 28100,
      Iw: 414000000,
      G: 10.6,
    },
    {
      nom: 'UPN 120',
      fam: 'U',
      h: 120,
      b: 55,
      tw: 7,
      tf: 9,
      r: 9,
      A: 1700,
      Iy: 3640000,
      Wely: 60700,
      Wply: 72600,
      iy: 46.2,
      Iz: 432000,
      Welz: 11100,
      Wplz: 21200,
      iz: 15.9,
      It: 41500,
      Iw: 900000000,
      G: 13.4,
    },
    {
      nom: 'UPN 140',
      fam: 'U',
      h: 140,
      b: 60,
      tw: 7,
      tf: 10,
      r: 10,
      A: 2039.9999999999998,
      Iy: 6050000,
      Wely: 86400,
      Wply: 103000,
      iy: 54.5,
      Iz: 627000,
      Welz: 14800,
      Wplz: 28300,
      iz: 17.5,
      It: 56800,
      Iw: 1800000000,
      G: 16,
    },
    {
      nom: 'UPN 160',
      fam: 'U',
      h: 160,
      b: 65,
      tw: 7.5,
      tf: 10.5,
      r: 10.5,
      A: 2400,
      Iy: 9250000,
      Wely: 116000,
      Wply: 138000,
      iy: 62.1,
      Iz: 853000,
      Welz: 18300,
      Wplz: 35200,
      iz: 18.9,
      It: 73900,
      Iw: 3260000000,
      G: 18.8,
    },
    {
      nom: 'UPN 180',
      fam: 'U',
      h: 180,
      b: 70,
      tw: 8,
      tf: 11,
      r: 11,
      A: 2800,
      Iy: 13500000,
      Wely: 150000,
      Wply: 179000,
      iy: 69.5,
      Iz: 1140000,
      Welz: 22400,
      Wplz: 42900,
      iz: 20.2,
      It: 95500,
      Iw: 5570000000,
      G: 22,
    },
    {
      nom: 'UPN 200',
      fam: 'U',
      h: 200,
      b: 75,
      tw: 8.5,
      tf: 11.5,
      r: 11.5,
      A: 3220.0000000000005,
      Iy: 19100000,
      Wely: 191000,
      Wply: 228000,
      iy: 77,
      Iz: 1480000,
      Welz: 27000,
      Wplz: 51800,
      iz: 21.400000000000002,
      It: 119000,
      Iw: 9070000000,
      G: 25.3,
    },
    {
      nom: 'UPN 220',
      fam: 'U',
      h: 220,
      b: 80,
      tw: 9,
      tf: 12.5,
      r: 12.5,
      A: 3740,
      Iy: 26900000,
      Wely: 245000,
      Wply: 292000,
      iy: 84.80000000000001,
      Iz: 1970000,
      Welz: 33600,
      Wplz: 64099.99999999999,
      iz: 23,
      It: 160000,
      Iw: 14600000000,
      G: 29.4,
    },
    {
      nom: 'UPN 240',
      fam: 'U',
      h: 240,
      b: 85,
      tw: 9.5,
      tf: 13,
      r: 13,
      A: 4230,
      Iy: 36000000,
      Wely: 300000,
      Wply: 358000,
      iy: 92.2,
      Iz: 2480000,
      Welz: 39600,
      Wplz: 75700,
      iz: 24.2,
      It: 197000,
      Iw: 22100000000,
      G: 33.2,
    },
    {
      nom: 'UPN 260',
      fam: 'U',
      h: 260,
      b: 90,
      tw: 10,
      tf: 14,
      r: 14,
      A: 4830,
      Iy: 48200000,
      Wely: 371000,
      Wply: 442000,
      iy: 99.9,
      Iz: 3170000,
      Welz: 47700,
      Wplz: 91600,
      iz: 25.6,
      It: 255000,
      Iw: 33300000000,
      G: 37.9,
    },
    {
      nom: 'UPN 280',
      fam: 'U',
      h: 280,
      b: 95,
      tw: 10,
      tf: 15,
      r: 15,
      A: 5330,
      Iy: 62800000,
      Wely: 448000,
      Wply: 532000,
      iy: 109,
      Iz: 3990000,
      Welz: 57200,
      Wplz: 109000,
      iz: 27.400000000000002,
      It: 310000,
      Iw: 48500000000,
      G: 41.8,
    },
    {
      nom: 'UPN 300',
      fam: 'U',
      h: 300,
      b: 100,
      tw: 10,
      tf: 16,
      r: 16,
      A: 5880,
      Iy: 80300000,
      Wely: 535000,
      Wply: 632000,
      iy: 117,
      Iz: 4950000,
      Welz: 67800,
      Wplz: 130000,
      iz: 29,
      It: 374000,
      Iw: 69100000000,
      G: 46.2,
    },
  ],
  nuances: [
    { n: 'S235', fy1: 235, fy2: 215, fu1: 360, fu2: 360 },
    { n: 'S275', fy1: 275, fy2: 255, fu1: 430, fu2: 410 },
    { n: 'S355', fy1: 355, fy2: 335, fu1: 490, fu2: 470 },
    { n: 'S420', fy1: 420, fy2: 390, fu1: 520, fu2: 520 },
    { n: 'S460', fy1: 460, fy2: 430, fu1: 540, fu2: 540 },
  ],
  schemas: [
    {
      n: 'Isostatique (appuis simples)',
      Cq: 0.0130208333333333,
      Cp: 0.0208333333333333,
      note: 'w = Cq q L4/EI + Cp P L3/EI  -  P a mi-portee',
    },
    { n: 'Bi-encastree', Cq: 0.00260416666666667, Cp: 0.00520833333333333, note: 'P a mi-portee' },
    {
      n: 'Console (encastree - libre)',
      Cq: 0.125,
      Cp: 0.333333333333333,
      note: 'L = longueur de la console, P en bout',
    },
    {
      n: 'Continue - 2 travees egales',
      Cq: 0.00542,
      Cp: 0.01466,
      note: 'Fleche maxi en travee, travees egales',
    },
    {
      n: 'Continue - 3 travees egales',
      Cq: 0.0069,
      Cp: 0.0159,
      note: 'Fleche maxi en travee de rive',
    },
  ],
  creux: [
    { nom: 'Personnalise', h: 0, b: 0, t: 0 },
    { nom: 'SHS 40x40x3', h: 40, b: 40, t: 3 },
    { nom: 'SHS 40x40x4', h: 40, b: 40, t: 4 },
    { nom: 'SHS 50x50x3', h: 50, b: 50, t: 3 },
    { nom: 'SHS 50x50x4', h: 50, b: 50, t: 4 },
    { nom: 'SHS 50x50x5', h: 50, b: 50, t: 5 },
    { nom: 'SHS 60x60x3', h: 60, b: 60, t: 3 },
    { nom: 'SHS 60x60x4', h: 60, b: 60, t: 4 },
    { nom: 'SHS 60x60x5', h: 60, b: 60, t: 5 },
    { nom: 'SHS 60x60x6', h: 60, b: 60, t: 6 },
    { nom: 'SHS 70x70x3', h: 70, b: 70, t: 3 },
    { nom: 'SHS 70x70x4', h: 70, b: 70, t: 4 },
    { nom: 'SHS 70x70x5', h: 70, b: 70, t: 5 },
    { nom: 'SHS 70x70x6', h: 70, b: 70, t: 6 },
    { nom: 'SHS 80x80x3', h: 80, b: 80, t: 3 },
    { nom: 'SHS 80x80x4', h: 80, b: 80, t: 4 },
    { nom: 'SHS 80x80x5', h: 80, b: 80, t: 5 },
    { nom: 'SHS 80x80x6', h: 80, b: 80, t: 6 },
    { nom: 'SHS 80x80x8', h: 80, b: 80, t: 8 },
    { nom: 'SHS 90x90x4', h: 90, b: 90, t: 4 },
    { nom: 'SHS 90x90x5', h: 90, b: 90, t: 5 },
    { nom: 'SHS 90x90x6', h: 90, b: 90, t: 6 },
    { nom: 'SHS 90x90x8', h: 90, b: 90, t: 8 },
    { nom: 'SHS 100x100x3', h: 100, b: 100, t: 3 },
    { nom: 'SHS 100x100x4', h: 100, b: 100, t: 4 },
    { nom: 'SHS 100x100x5', h: 100, b: 100, t: 5 },
    { nom: 'SHS 100x100x6', h: 100, b: 100, t: 6 },
    { nom: 'SHS 100x100x8', h: 100, b: 100, t: 8 },
    { nom: 'SHS 100x100x10', h: 100, b: 100, t: 10 },
    { nom: 'SHS 120x120x4', h: 120, b: 120, t: 4 },
    { nom: 'SHS 120x120x5', h: 120, b: 120, t: 5 },
    { nom: 'SHS 120x120x6', h: 120, b: 120, t: 6 },
    { nom: 'SHS 120x120x8', h: 120, b: 120, t: 8 },
    { nom: 'SHS 120x120x10', h: 120, b: 120, t: 10 },
    { nom: 'SHS 140x140x5', h: 140, b: 140, t: 5 },
    { nom: 'SHS 140x140x6', h: 140, b: 140, t: 6 },
    { nom: 'SHS 140x140x8', h: 140, b: 140, t: 8 },
    { nom: 'SHS 140x140x10', h: 140, b: 140, t: 10 },
    { nom: 'SHS 150x150x5', h: 150, b: 150, t: 5 },
    { nom: 'SHS 150x150x6', h: 150, b: 150, t: 6 },
    { nom: 'SHS 150x150x8', h: 150, b: 150, t: 8 },
    { nom: 'SHS 150x150x10', h: 150, b: 150, t: 10 },
    { nom: 'SHS 150x150x12.5', h: 150, b: 150, t: 12.5 },
    { nom: 'SHS 160x160x5', h: 160, b: 160, t: 5 },
    { nom: 'SHS 160x160x6', h: 160, b: 160, t: 6 },
    { nom: 'SHS 160x160x8', h: 160, b: 160, t: 8 },
    { nom: 'SHS 160x160x10', h: 160, b: 160, t: 10 },
    { nom: 'SHS 160x160x12.5', h: 160, b: 160, t: 12.5 },
    { nom: 'SHS 180x180x6', h: 180, b: 180, t: 6 },
    { nom: 'SHS 180x180x8', h: 180, b: 180, t: 8 },
    { nom: 'SHS 180x180x10', h: 180, b: 180, t: 10 },
    { nom: 'SHS 180x180x12.5', h: 180, b: 180, t: 12.5 },
    { nom: 'SHS 200x200x6', h: 200, b: 200, t: 6 },
    { nom: 'SHS 200x200x8', h: 200, b: 200, t: 8 },
    { nom: 'SHS 200x200x10', h: 200, b: 200, t: 10 },
    { nom: 'SHS 200x200x12.5', h: 200, b: 200, t: 12.5 },
    { nom: 'SHS 200x200x16', h: 200, b: 200, t: 16 },
    { nom: 'SHS 250x250x8', h: 250, b: 250, t: 8 },
    { nom: 'SHS 250x250x10', h: 250, b: 250, t: 10 },
    { nom: 'SHS 250x250x12.5', h: 250, b: 250, t: 12.5 },
    { nom: 'SHS 250x250x16', h: 250, b: 250, t: 16 },
    { nom: 'SHS 300x300x8', h: 300, b: 300, t: 8 },
    { nom: 'SHS 300x300x10', h: 300, b: 300, t: 10 },
    { nom: 'SHS 300x300x12.5', h: 300, b: 300, t: 12.5 },
    { nom: 'SHS 300x300x16', h: 300, b: 300, t: 16 },
    { nom: 'SHS 350x350x10', h: 350, b: 350, t: 10 },
    { nom: 'SHS 350x350x12.5', h: 350, b: 350, t: 12.5 },
    { nom: 'SHS 350x350x16', h: 350, b: 350, t: 16 },
    { nom: 'SHS 400x400x10', h: 400, b: 400, t: 10 },
    { nom: 'SHS 400x400x12.5', h: 400, b: 400, t: 12.5 },
    { nom: 'SHS 400x400x16', h: 400, b: 400, t: 16 },
    { nom: 'RHS 50x30x3', h: 50, b: 30, t: 3 },
    { nom: 'RHS 50x30x4', h: 50, b: 30, t: 4 },
    { nom: 'RHS 60x40x3', h: 60, b: 40, t: 3 },
    { nom: 'RHS 60x40x4', h: 60, b: 40, t: 4 },
    { nom: 'RHS 60x40x5', h: 60, b: 40, t: 5 },
    { nom: 'RHS 70x50x3', h: 70, b: 50, t: 3 },
    { nom: 'RHS 70x50x4', h: 70, b: 50, t: 4 },
    { nom: 'RHS 70x50x5', h: 70, b: 50, t: 5 },
    { nom: 'RHS 80x40x3', h: 80, b: 40, t: 3 },
    { nom: 'RHS 80x40x4', h: 80, b: 40, t: 4 },
    { nom: 'RHS 80x40x5', h: 80, b: 40, t: 5 },
    { nom: 'RHS 80x60x3', h: 80, b: 60, t: 3 },
    { nom: 'RHS 80x60x4', h: 80, b: 60, t: 4 },
    { nom: 'RHS 80x60x5', h: 80, b: 60, t: 5 },
    { nom: 'RHS 80x60x6', h: 80, b: 60, t: 6 },
    { nom: 'RHS 90x50x3', h: 90, b: 50, t: 3 },
    { nom: 'RHS 90x50x4', h: 90, b: 50, t: 4 },
    { nom: 'RHS 90x50x5', h: 90, b: 50, t: 5 },
    { nom: 'RHS 100x50x3', h: 100, b: 50, t: 3 },
    { nom: 'RHS 100x50x4', h: 100, b: 50, t: 4 },
    { nom: 'RHS 100x50x5', h: 100, b: 50, t: 5 },
    { nom: 'RHS 100x50x6', h: 100, b: 50, t: 6 },
    { nom: 'RHS 100x60x3', h: 100, b: 60, t: 3 },
    { nom: 'RHS 100x60x4', h: 100, b: 60, t: 4 },
    { nom: 'RHS 100x60x5', h: 100, b: 60, t: 5 },
    { nom: 'RHS 100x60x6', h: 100, b: 60, t: 6 },
    { nom: 'RHS 100x80x4', h: 100, b: 80, t: 4 },
    { nom: 'RHS 100x80x5', h: 100, b: 80, t: 5 },
    { nom: 'RHS 100x80x6', h: 100, b: 80, t: 6 },
    { nom: 'RHS 100x80x8', h: 100, b: 80, t: 8 },
    { nom: 'RHS 120x60x4', h: 120, b: 60, t: 4 },
    { nom: 'RHS 120x60x5', h: 120, b: 60, t: 5 },
    { nom: 'RHS 120x60x6', h: 120, b: 60, t: 6 },
    { nom: 'RHS 120x60x8', h: 120, b: 60, t: 8 },
    { nom: 'RHS 120x80x4', h: 120, b: 80, t: 4 },
    { nom: 'RHS 120x80x5', h: 120, b: 80, t: 5 },
    { nom: 'RHS 120x80x6', h: 120, b: 80, t: 6 },
    { nom: 'RHS 120x80x8', h: 120, b: 80, t: 8 },
    { nom: 'RHS 140x80x5', h: 140, b: 80, t: 5 },
    { nom: 'RHS 140x80x6', h: 140, b: 80, t: 6 },
    { nom: 'RHS 140x80x8', h: 140, b: 80, t: 8 },
    { nom: 'RHS 140x80x10', h: 140, b: 80, t: 10 },
    { nom: 'RHS 150x100x5', h: 150, b: 100, t: 5 },
    { nom: 'RHS 150x100x6', h: 150, b: 100, t: 6 },
    { nom: 'RHS 150x100x8', h: 150, b: 100, t: 8 },
    { nom: 'RHS 150x100x10', h: 150, b: 100, t: 10 },
    { nom: 'RHS 160x80x5', h: 160, b: 80, t: 5 },
    { nom: 'RHS 160x80x6', h: 160, b: 80, t: 6 },
    { nom: 'RHS 160x80x8', h: 160, b: 80, t: 8 },
    { nom: 'RHS 160x80x10', h: 160, b: 80, t: 10 },
    { nom: 'RHS 180x100x5', h: 180, b: 100, t: 5 },
    { nom: 'RHS 180x100x6', h: 180, b: 100, t: 6 },
    { nom: 'RHS 180x100x8', h: 180, b: 100, t: 8 },
    { nom: 'RHS 180x100x10', h: 180, b: 100, t: 10 },
    { nom: 'RHS 200x100x5', h: 200, b: 100, t: 5 },
    { nom: 'RHS 200x100x6', h: 200, b: 100, t: 6 },
    { nom: 'RHS 200x100x8', h: 200, b: 100, t: 8 },
    { nom: 'RHS 200x100x10', h: 200, b: 100, t: 10 },
    { nom: 'RHS 200x100x12.5', h: 200, b: 100, t: 12.5 },
    { nom: 'RHS 200x120x6', h: 200, b: 120, t: 6 },
    { nom: 'RHS 200x120x8', h: 200, b: 120, t: 8 },
    { nom: 'RHS 200x120x10', h: 200, b: 120, t: 10 },
    { nom: 'RHS 200x120x12.5', h: 200, b: 120, t: 12.5 },
    { nom: 'RHS 250x150x6', h: 250, b: 150, t: 6 },
    { nom: 'RHS 250x150x8', h: 250, b: 150, t: 8 },
    { nom: 'RHS 250x150x10', h: 250, b: 150, t: 10 },
    { nom: 'RHS 250x150x12.5', h: 250, b: 150, t: 12.5 },
    { nom: 'RHS 300x200x8', h: 300, b: 200, t: 8 },
    { nom: 'RHS 300x200x10', h: 300, b: 200, t: 10 },
    { nom: 'RHS 300x200x12.5', h: 300, b: 200, t: 12.5 },
    { nom: 'RHS 300x200x16', h: 300, b: 200, t: 16 },
    { nom: 'RHS 400x200x10', h: 400, b: 200, t: 10 },
    { nom: 'RHS 400x200x12.5', h: 400, b: 200, t: 12.5 },
    { nom: 'RHS 400x200x16', h: 400, b: 200, t: 16 },
  ],
  fabrication: [
    { n: 'Fini a chaud (EN 10210)', rot: 1.5, courbe: 'a' },
    { n: 'Forme a froid (EN 10219)', rot: 2, courbe: 'c' },
  ],
  bois: [
    {
      classe: 'C14',
      fmk: 14,
      ft0k: 8,
      ft90k: 0.4,
      fc0k: 16,
      fc90k: 2,
      fvk: 3,
      E0mean: 7000,
      E005: 4700,
      Gmean: 440,
      rhok: 290,
      rhomean: 350,
      gammaM: 1.3,
      betac: 0.2,
      khref: 150,
      khexp: 0.2,
      khmax: 1.3,
      type: 'Bois massif',
      kfi: 1.25,
    },
    {
      classe: 'C16',
      fmk: 16,
      ft0k: 10,
      ft90k: 0.4,
      fc0k: 17,
      fc90k: 2.2,
      fvk: 3.2,
      E0mean: 8000,
      E005: 5400,
      Gmean: 500,
      rhok: 310,
      rhomean: 370,
      gammaM: 1.3,
      betac: 0.2,
      khref: 150,
      khexp: 0.2,
      khmax: 1.3,
      type: 'Bois massif',
      kfi: 1.25,
    },
    {
      classe: 'C18',
      fmk: 18,
      ft0k: 11,
      ft90k: 0.4,
      fc0k: 18,
      fc90k: 2.2,
      fvk: 3.4,
      E0mean: 9000,
      E005: 6000,
      Gmean: 560,
      rhok: 320,
      rhomean: 380,
      gammaM: 1.3,
      betac: 0.2,
      khref: 150,
      khexp: 0.2,
      khmax: 1.3,
      type: 'Bois massif',
      kfi: 1.25,
    },
    {
      classe: 'C20',
      fmk: 20,
      ft0k: 12,
      ft90k: 0.4,
      fc0k: 19,
      fc90k: 2.3,
      fvk: 3.6,
      E0mean: 9500,
      E005: 6400,
      Gmean: 590,
      rhok: 330,
      rhomean: 390,
      gammaM: 1.3,
      betac: 0.2,
      khref: 150,
      khexp: 0.2,
      khmax: 1.3,
      type: 'Bois massif',
      kfi: 1.25,
    },
    {
      classe: 'C22',
      fmk: 22,
      ft0k: 13,
      ft90k: 0.4,
      fc0k: 20,
      fc90k: 2.4,
      fvk: 3.8,
      E0mean: 10000,
      E005: 6700,
      Gmean: 630,
      rhok: 340,
      rhomean: 410,
      gammaM: 1.3,
      betac: 0.2,
      khref: 150,
      khexp: 0.2,
      khmax: 1.3,
      type: 'Bois massif',
      kfi: 1.25,
    },
    {
      classe: 'C24',
      fmk: 24,
      ft0k: 14,
      ft90k: 0.4,
      fc0k: 21,
      fc90k: 2.5,
      fvk: 4,
      E0mean: 11000,
      E005: 7400,
      Gmean: 690,
      rhok: 350,
      rhomean: 420,
      gammaM: 1.3,
      betac: 0.2,
      khref: 150,
      khexp: 0.2,
      khmax: 1.3,
      type: 'Bois massif',
      kfi: 1.25,
    },
    {
      classe: 'C27',
      fmk: 27,
      ft0k: 16,
      ft90k: 0.4,
      fc0k: 22,
      fc90k: 2.6,
      fvk: 4,
      E0mean: 11500,
      E005: 7700,
      Gmean: 720,
      rhok: 370,
      rhomean: 450,
      gammaM: 1.3,
      betac: 0.2,
      khref: 150,
      khexp: 0.2,
      khmax: 1.3,
      type: 'Bois massif',
      kfi: 1.25,
    },
    {
      classe: 'C30',
      fmk: 30,
      ft0k: 18,
      ft90k: 0.4,
      fc0k: 23,
      fc90k: 2.7,
      fvk: 4,
      E0mean: 12000,
      E005: 8000,
      Gmean: 750,
      rhok: 380,
      rhomean: 460,
      gammaM: 1.3,
      betac: 0.2,
      khref: 150,
      khexp: 0.2,
      khmax: 1.3,
      type: 'Bois massif',
      kfi: 1.25,
    },
    {
      classe: 'C35',
      fmk: 35,
      ft0k: 21,
      ft90k: 0.4,
      fc0k: 25,
      fc90k: 2.8,
      fvk: 4,
      E0mean: 13000,
      E005: 8700,
      Gmean: 810,
      rhok: 390,
      rhomean: 470,
      gammaM: 1.3,
      betac: 0.2,
      khref: 150,
      khexp: 0.2,
      khmax: 1.3,
      type: 'Bois massif',
      kfi: 1.25,
    },
    {
      classe: 'C40',
      fmk: 40,
      ft0k: 24,
      ft90k: 0.4,
      fc0k: 26,
      fc90k: 2.9,
      fvk: 4,
      E0mean: 14000,
      E005: 9400,
      Gmean: 880,
      rhok: 400,
      rhomean: 480,
      gammaM: 1.3,
      betac: 0.2,
      khref: 150,
      khexp: 0.2,
      khmax: 1.3,
      type: 'Bois massif',
      kfi: 1.25,
    },
    {
      classe: 'GL24h',
      fmk: 24,
      ft0k: 19.2,
      ft90k: 0.5,
      fc0k: 24,
      fc90k: 2.5,
      fvk: 3.5,
      E0mean: 11500,
      E005: 9600,
      Gmean: 650,
      rhok: 385,
      rhomean: 420,
      gammaM: 1.25,
      betac: 0.1,
      khref: 600,
      khexp: 0.1,
      khmax: 1.1,
      type: 'Lamelle-colle',
      kfi: 1.15,
    },
    {
      classe: 'GL28h',
      fmk: 28,
      ft0k: 22.3,
      ft90k: 0.5,
      fc0k: 28,
      fc90k: 2.5,
      fvk: 3.5,
      E0mean: 12600,
      E005: 10500,
      Gmean: 650,
      rhok: 425,
      rhomean: 460,
      gammaM: 1.25,
      betac: 0.1,
      khref: 600,
      khexp: 0.1,
      khmax: 1.1,
      type: 'Lamelle-colle',
      kfi: 1.15,
    },
    {
      classe: 'GL32h',
      fmk: 32,
      ft0k: 25.6,
      ft90k: 0.5,
      fc0k: 32,
      fc90k: 2.5,
      fvk: 3.5,
      E0mean: 14200,
      E005: 11800,
      Gmean: 650,
      rhok: 440,
      rhomean: 490,
      gammaM: 1.25,
      betac: 0.1,
      khref: 600,
      khexp: 0.1,
      khmax: 1.1,
      type: 'Lamelle-colle',
      kfi: 1.15,
    },
    {
      classe: 'GL24c',
      fmk: 24,
      ft0k: 17,
      ft90k: 0.5,
      fc0k: 21.5,
      fc90k: 2.5,
      fvk: 3.5,
      E0mean: 11000,
      E005: 9100,
      Gmean: 650,
      rhok: 365,
      rhomean: 400,
      gammaM: 1.25,
      betac: 0.1,
      khref: 600,
      khexp: 0.1,
      khmax: 1.1,
      type: 'Lamelle-colle',
      kfi: 1.15,
    },
    {
      classe: 'GL28c',
      fmk: 28,
      ft0k: 19.5,
      ft90k: 0.5,
      fc0k: 24,
      fc90k: 2.5,
      fvk: 3.5,
      E0mean: 12500,
      E005: 10400,
      Gmean: 650,
      rhok: 390,
      rhomean: 420,
      gammaM: 1.25,
      betac: 0.1,
      khref: 600,
      khexp: 0.1,
      khmax: 1.1,
      type: 'Lamelle-colle',
      kfi: 1.15,
    },
    {
      classe: 'GL32c',
      fmk: 32,
      ft0k: 19.5,
      ft90k: 0.5,
      fc0k: 24.5,
      fc90k: 2.5,
      fvk: 3.5,
      E0mean: 13500,
      E005: 11200,
      Gmean: 650,
      rhok: 400,
      rhomean: 440,
      gammaM: 1.25,
      betac: 0.1,
      khref: 600,
      khexp: 0.1,
      khmax: 1.1,
      type: 'Lamelle-colle',
      kfi: 1.15,
    },
  ],
  kmod: [
    { cs: 1, vals: [0.6, 0.7, 0.8, 0.9, 1.1] },
    { cs: 2, vals: [0.6, 0.7, 0.8, 0.9, 1.1] },
    { cs: 3, vals: [0.5, 0.55, 0.65, 0.7, 0.9] },
  ],
  duree: ['Permanente', 'Long terme', 'Moyen terme', 'Court terme', 'Instantanee'],
  kdef: [
    { cs: 1, kdef: 0.6 },
    { cs: 2, kdef: 0.8 },
    { cs: 3, kdef: 2 },
  ],
};
